import { render } from "./card.vue?vue&type=template&id=260773e4&scoped=true&ts=true"
import script from "./card.vue?vue&type=script&lang=ts"
export * from "./card.vue?vue&type=script&lang=ts"

import "./card.vue?vue&type=style&index=0&id=260773e4&lang=less&scoped=true"

import exportComponent from "/vercel/path2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260773e4"]])

export default __exports__